(function(){
  if (window.__nvCodLoc) return; window.__nvCodLoc = 1;
  var loc = (window.NV_LOC || document.documentElement.lang || 'es').toLowerCase();
  var PT = loc.indexOf('pt') === 0;
  var CC = PT ? 'PT' : 'ES';
  var M = {
    'Introduce tus datos para completar tu pedido.': 'Introduza os seus dados para concluir a sua encomenda.',
    'Nombre y apellidos': 'Nome e apelido',
    'Número de teléfono': 'Número de telemóvel',
    'Email (opcional)': 'Email (opcional)',
    'Ciudad': 'Localidade',
    'Dirección completa': 'Morada completa',
    'Calle, número, piso y puerta': 'Rua, número, andar e porta',
    'Código postal': 'Código postal',
    'Provincia': 'Distrito',
    'PEDIR AHORA': 'ENCOMENDAR AGORA',
    'Pago al recibir': 'Paga na entrega',
    'Descuento': 'Desconto',
    'Envío': 'Envio',
    'Envío gratis': 'Envio grátis',
    'Opciones de envío': 'Opções de envio',
    'IVA incluido': 'IVA incluído',
    'Este campo es obligatorio.': 'Este campo é obrigatório.',
    'Este campo no es válido.': 'Este campo não é válido.',
    '1 Inflador': '1 Insuflador',
    '2 Infladores (tu coche + el de tu pareja)': '2 Insufladores (o seu carro + o do seu parceiro)',
    'Ahorras 17,90 €': 'Poupa 17,90 €',
    'REGALO PERFECTO': 'PRENDA PERFEITA',
    '1 Masajeador': '1 Massajador',
    '2 Masajeadores (para ti + para tu madre)': '2 Massajadores (para si + para a sua mãe)',
    'Ahorras 20,90 €': 'Poupa 20,90 €',
    'Resumen del pedido': 'Resumo da encomenda',
    'Pagas al recibirlo': 'Paga quando receber'
  };
  var SUB = [['(tu coche + el de tu pareja)','(o seu carro + o do seu parceiro)'],['(para ti + para tu madre)','(para si + para a sua mãe)'],['Infladores','Insufladores'],['Inflador','Insuflador'],['Masajeadores','Massajadores'],['Masajeador','Massajador'],['Precio unitario','Preço unitário'],['Ahorras ','Poupa '],[' c/u',' cada'],['REGALO PERFECTO','PRENDA PERFEITA'],['LA MÁS ELEGIDA','A MAIS ESCOLHIDA'],['Correo electrónico','E-mail']];
  var ISLANDS = PT ? ['PT_20','PT_30'] : [];
  function tr(s){ var k = s.replace(/\s+/g,' ').trim(); if (M[k]) return s.replace(k, M[k]); var t = k.replace(/\s*\*$/,''); if (t !== k && M[t]) return s.replace(t, M[t]); var o = s; SUB.forEach(function(p){ if (o.indexOf(p[0]) > -1 && o.indexOf(p[1]) < 0) o = o.split(p[0]).join(p[1]); }); return o !== s ? o : null; }
  function fixCountry(root){
    var c = root.querySelector('select[name="country"]');
    if (c){
      if (c.value !== CC && [].some.call(c.options, function(o){ return o.value === CC; })){
        c.value = CC; c.dispatchEvent(new Event('change',{bubbles:true})); c.dispatchEvent(new Event('input',{bubbles:true}));
      }
      var box = c.closest('.es-country-container') || c.parentElement; if (box && box.style.display !== 'none') box.style.display = 'none';
    }
    var p = root.querySelector('select[name="province"]');
    if (p && ISLANDS.length){ [].slice.call(p.options).forEach(function(o){ if (ISLANDS.indexOf(o.value) > -1) o.remove(); }); }
    if (p && PT && p.options[0] && p.options[0].value === '' && p.options[0].text === 'Provincia') p.options[0].text = 'Distrito';
  }
  function translate(root){
    if (!PT) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function(n){ if (!n.nodeValue || !n.nodeValue.trim()) return; var r = tr(n.nodeValue); if (r !== null && r !== n.nodeValue) n.nodeValue = r; });
    [].forEach.call(root.querySelectorAll('[placeholder]'), function(el){ var r = tr(el.getAttribute('placeholder') || ''); if (r !== null) el.setAttribute('placeholder', r); });
  }
  function run(){
    var nodes = document.querySelectorAll('[class^="es-"], [class*=" es-"], .nv-offers');
    if (!nodes.length) return;
    var seen = [];
    [].forEach.call(nodes, function(el){ var top = el; while (top.parentElement && / ?es-/.test(' ' + String(top.parentElement.className))) top = top.parentElement; if (seen.indexOf(top) < 0) seen.push(top); });
    seen.forEach(function(r){ fixCountry(r); translate(r); });
  }
  var busy = false;
  var mo = new MutationObserver(function(){ if (busy) return; busy = true; requestAnimationFrame(function(){ mo.disconnect(); try { run(); } finally { mo.observe(document.body, {childList:true, subtree:true, characterData:true}); busy = false; } }); });
  function start(){ run(); mo.observe(document.body, {childList:true, subtree:true, characterData:true}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
